import { isNullOrUndefined } from '@weft/utils';
import { useMemo } from 'react';
import { deserializeStringArrayParam } from '../../../../utils/params-formatting';
import type { DataMeteringParamsIds } from './data-metering-param-ids';

export function useDataMeteringParamsIds(searchParams: URLSearchParams) {
  const customersIds = useMemo(() => {
    return searchParams.get('customers') ? searchParams.get('customers')?.split(',') : [];
  }, [searchParams]);

  const eventNames = useMemo(() => {
    const paramEventNames = searchParams.get('eventNames');
    if (isNullOrUndefined(paramEventNames)) {
      return [];
    }

    return deserializeStringArrayParam(paramEventNames);
  }, [searchParams]);

  const metersIds = useMemo(() => {
    return searchParams.get('meters')?.split(',');
  }, [searchParams]);

  return useMemo<DataMeteringParamsIds>(() => ({
    customersIds,
    eventNames,
    metersIds,
  }), [customersIds, eventNames, metersIds]);  
}